<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
           <!--
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15002842221.jpg"
                alt=""
                title="" /></a>
          </div>
          -->
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011452161.png"
                alt=""
                title=""/></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <router-link :to="{name:'首頁'}" class="breadCrumb_no" title="首頁">首頁</router-link>
        <router-link :to="{name:'營業據點'}"><span>聯絡我們</span></router-link>
        <router-link :to="{name:'營業據點'}"><span>營業據點</span></router-link>
      </div>

      <h2 class="titleA">營業據點</h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'營業據點'}" class="menu_on0">聯絡我們</router-link>
              <span
                style="cursor: hand"
                class="arrow_class_close"
                onclick="allshow_show_menu2(this,'2313','http://www.ptotinc.com/','0','','2315')">
                <img
                  src="~@/assets/folder_close.png"
                  id="img_son_menu_2313"
                  class="class_sonimg_0"/>
              </span>
            </li>
            <div id="son_menu_2279" class="class_sondiv_0" style="display: ">
              <ol>
                <router-link :to="{name:'營業據點'}" class="menu_on2">營業據點</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'聯絡方式'}" class="menu_on0">聯絡方式</router-link>
              </ol>

            </div>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">

          <form method="POST" action="portal_c2_cnt.php?owner_num=c2_38777&button_num=c2&folder_id=2315&search_type=1">

            <div class="searchbar">
              <ul>
                <li>

                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input tabindex="63" name="search_word" type="text" class="input" value="" />
                  <input tabindex="64" name="search_b1" type="submit" class="btn" value="查詢" />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_38777&button_num=c2&folder_id=2315&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>
          <div class="cate_info"> &nbsp;
            <div class="s631_world">
              <div class="s631_world_w">
                <h2>林口總公司</h2>

                <p>地址：桃園市龜山區華亞科技園區科技二路37號</p>

                <p>電話：+886-3-211-5526</p>

                <p>傳真：+886-3-211-5293</p>
              </div>

              <div class="s631_world_map" style="display: none;">&lt;&gt;<iframe allowfullscreen="" frameborder="0"
                  height="200" scrolling="no"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d904.9423004215204!2d121.03124082924024!3d24.87173109900304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb5fc88e4bc667b0b!2z5Z2k6Lyd56eR5oqA5a-m5qWt6IKh5Lu95pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2stw!4v1502416953267"
                  style="border: 0px currentColor; border-image: none;" width="100%"></iframe></div>
            </div>

            <div class="s631_world_map"><img alt=""
                src="~@/assets/branch_1.jpg"
                style="width: 798px; height: 200px;" /></div>
            &nbsp;

            <div class="s631_world">
              <div class="s631_world_w">
                <h2>湖口廠</h2>

                <p>地址：新竹縣湖口鄉光復路8號</p>

                <p>電話：+886-3-598-6390</p>

                <p>傳真：+886-3-598-6397</p>
              </div>

              <div class="s631_world_map" style="display: none;">&lt;&gt;<iframe allowfullscreen="" frameborder="0"
                  height="200" scrolling="no"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d904.9423004215204!2d121.03124082924024!3d24.87173109900304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb5fc88e4bc667b0b!2z5Z2k6Lyd56eR5oqA5a-m5qWt6IKh5Lu95pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2stw!4v1502416953267"
                  style="border: 0px currentColor; border-image: none;" width="100%"></iframe></div>
            </div>

            <div class="s631_world_map"><img alt=""
                src="~@/assets/branch_2.jpg"
                style="width: 798px; height: 200px;" /></div>
            &nbsp;


            
          </div>

          <ul id="c_list">
          </ul>




          <br><br>
          <p style="text-align:center;">
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'branch',
  data () {
    return {
      isAboutPage: true
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      // initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/contactus/Branch.vue